import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import fr from './locales/fr.json';
import en from './locales/en.json';
import ar from './locales/ar.json';
import es from './locales/es.json';
import ur from './locales/ur.json';
import sl from './locales/sl.json';
import de from './locales/de.json';
import sq from './locales/sq.json';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    debug: false,
    fallbackLng: 'en',
    supportedLngs: ['fr', 'en', 'ar', 'es', 'ur', 'sl', 'de', 'sq'],
    nonExplicitSupportedLngs: true,
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },
    resources: {
      fr: {
        translation: fr
      },
      en: {
        translation: en
      },
      ar: {
        translation: ar
      },
      es: {
        translation: es
      },
      ur: {
        translation: ur
      },
      sl: {
        translation: sl
      },
      de: {
        translation: de
      },
      sq: {
        translation: sq
      }
    },
    detection: {
      order: ['localStorage', 'cookie', 'navigator', 'htmlTag', 'path', 'subdomain'],
      caches: ['localStorage', 'cookie'],
    },
  });

export default i18n;